import * as React from 'react'
import { ComponentPropsWithoutRef } from 'react'
import * as Styled from './styles'

type ContainerProps = {
  children?: React.ReactNode
  containerRef?: React.Ref<HTMLDivElement>
}

export const Container = ({
  children,
  containerRef,
  ...props
}: ContainerProps & ComponentPropsWithoutRef<'div'>) => (
  <Styled.Wrapper {...props} ref={containerRef}>
    {children}
  </Styled.Wrapper>
)
